/**
 * The Admeru logo — the only logo the app shows. Mark (favicon.svg) + wordmark, with the
 * wordmark's light version on light backgrounds and its dark version on dark ones.
 *
 *   <Logo />                     theme-aware, links home
 *   <Logo onDark height={28} />  on navy panels (sidebar, auth, legal)
 *   <Logo mark />                the mark alone (collapsed sidebar, avatars)
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@/hooks/useTheme';

const MARK = '/images/branding/logos/favicon.svg';
const WORDMARK = (dark: boolean) => `/images/branding/logos/wordmark/logo-wordmark-${dark ? 'dark' : 'light'}.svg`;

interface LogoProps {
  /** Height in px of the mark and the wordmark. */
  height?: number;
  /** The background is dark (navy panel). Defaults to the current theme. */
  onDark?: boolean;
  /** Show only the mark. */
  mark?: boolean;
  /** Link destination; pass null for no link. */
  to?: string | null;
  className?: string;
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({ height = 28, onDark, mark, to = '/', className = '', onClick }) => {
  const { theme } = useTheme();
  const dark = onDark ?? theme === 'dark';
  const img = (
    <span className={`inline-flex shrink-0 items-center gap-1.5 ${className}`}>
      <img src={MARK} alt={mark ? 'admeru' : ''} style={{ height, width: 'auto' }} className="block" />
      {!mark && <img src={WORDMARK(dark)} alt="admeru" style={{ height, width: 'auto' }} className="block" />}
    </span>
  );
  return to ? <Link to={to} onClick={onClick} aria-label="Admeru home" className="inline-flex no-underline">{img}</Link> : img;
};

export default Logo;
